import React from 'react';
import pt from 'prop-types';
import cn from 'classnames';
import styles from './Button.module.scss';

export default function Button({ children, className, variant, fullWidth, ...rest }) {
  const classes = {
    [styles.button]: true,
    [styles[variant]]: !!variant,
    [className]: !!className,
    [styles.fullWidth]: fullWidth,
  };

  return (
    // eslint-disable-next-line react/button-has-type
    <button className={cn(classes)} {...rest}>{children}</button>
  );
}

Button.defaultProps = {
  className: '',
  variant: 'primary',
  type: 'button',
};

Button.propTypes = {
  className: pt.string,
  variant: pt.oneOf(['', 'primary']),
  type: pt.oneOf(['button', 'submit']),
};
